var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('authorization',{attrs:{"permissionKey":"surgery_ward_preoperative_queue","can":"read"}},[_c('attendances',{attrs:{"queueType":"surgery_preoperative","medicalRecordPath":"cirurgia"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }